<template>
    <div>
        <button class="d-none" data-toggle="modal" data-target="#EventWizardSteps" ref="openEventWizard"></button>
        <div class="modal fade" id="EventWizardSteps" tabindex="-1" role="dialog" data-backdrop="static"
            data-keyboard="false">
            <div class="modal-dialog product-cart-modal" role="document">
                <div class="modal-content p-0">
                    <div class="modal-left-wrapper">
                        <div class="modal-header">
                            <h6 class="modal-title m-0">Event created. Let’s finish setting up your event!</h6>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                ref="closeModalEventWizards">
                                <img src="../../../assets/Svg/close-black.svg" />
                            </button>
                        </div>
                        <div class="modal-body mx-auto">
                            <div class="container-fluid p-0">
                                <div class="stepper d-flex justify-content-between">
                                    <div class="step"
                                        :class="{ active: currentStep === 1, completed: currentStep > 1 }">
                                        <div class="circle"></div>
                                        <div class="label">Seed Criteria</div>
                                    </div>

                                    <div class="step"
                                        :class="{ active: currentStep === 2, completed: currentStep > 2 }">
                                        <div class="circle"></div>
                                        <div class="label">Playing Facilities</div>
                                    </div>

                                    <div class="step"
                                        :class="{ active: currentStep === 3, completed: currentStep > 3 }">
                                        <div class="circle"></div>
                                        <div class="label">Hotels</div>
                                    </div>

                                    <div class="step" :class="{ active: currentStep === 4 }">
                                        <div class="circle"></div>
                                        <div class="label">Sponsors</div>
                                    </div>
                                </div>

                            </div>
                            <div v-if="currentStep === 1">
                                <div class="text-center mb-3">
                                    <h6 class="mb-2 head-sec">Select Seed Criteria</h6>
                                    <p class="mb-4 text-sec">Drag & drop available teams to choose how teams will be
                                        seeded for the
                                        tournament. This helps determine matchups and brackets based on skill, rankings,
                                        or random draw. </p>
                                    <SeedingComponent :eventId="eventId" :association_id="association_id"
                                        @update-state="handleUpdateSeedars" />
                                </div>
                            </div>
                            <div v-if="currentStep === 2">
                                <div class="text-center mb-3">
                                    <h6 class="mb-2 head-sec">Assign Playing Facilities</h6>
                                    <p class="mb-4 text-sec">Drag and drop available playing facilities or create new
                                        ones to assign to this
                                        event. These fields will be used for scheduling both pool and bracket games, so
                                        make sure all locations are accurate and game-ready.</p>
                                    <ParksComponent ref="parksComponent" :eventId="eventId" :association_id="association_id"
                                        @close-manage-modal="closeModal" @update-state="handleStateUpdate" />
                                </div>
                            </div>
                            <div v-if="currentStep === 3">
                                <div class="text-center mb-3">
                                    <h6 class="mb-2 head-sec">Connect Hotels To Event</h6>
                                    <p class="mb-4 text-sec">Search for partner using Google Maps. Once found, quickly
                                        add them to your event.
                                        These hotels will help teams plan their stay.</p>
                                    <div class="form-group d-flex" style="gap: 5px">
                                        <gmap-autocomplete :value="location"
                                            placeholder="Enter an address, zipcode, or location"
                                            @place_changed="setPlace" ref="autocompleteRef">
                                        </gmap-autocomplete>
                                        <button class="btn create-event" @click="newHotel()">Add Hotel</button>
                                    </div>
                                    <google-map :center="marker.position" :zoom="18" map-style-id="roadmap"
                                        :options="mapOptions" style="width: 100%; height: 50vmin; margin-bottom: 20px"
                                        ref="mapRef" id="map" @click="handleMapClick">
                                        <google-maps-marker :position="marker.position" :clickable="true"
                                            :draggable="true" @drag="handleThrottledMarkerDrag"
                                            @click="panToMarker"></google-maps-marker>
                                    </google-map>
                                </div>
                            </div>
                            <div v-if="currentStep === 4">
                                <div class="text-center mb-3">
                                    <h6 class="mb-2 head-sec">Manage Event Sponsors</h6>
                                    <p class="mb-4 text-sec">Recognize and promote the official sponsors of your event.
                                        Upload sponsor assets
                                        and show your appreciation by giving them visible placement during the
                                        tournament.</p>
                                    <div class="d-flex align-items-center justify-content-end">
                                        <button class="btn create-event" @click="newSponsor()">Add Sponsor</button>
                                    </div>
                                    <div class="products-list-shim" v-if="sponsorLoader == 1">
                                        <content-placeholders :rounded="true">
                                            <content-placeholders-img />
                                            <content-placeholders-heading />
                                        </content-placeholders>

                                    </div>
                                    <div class="sponsor-wrapper" v-else>
                                        <div class="sponsor-wrap">
                                            <div class="sponsor-content" v-for="(sponsor, index) in eventSponsors"
                                                :key="index" style="max-width: 200px;">
                                                <div class="sponsor-info">
                                                    <div class="sponsor-img" v-if="sponsor.image_url">
                                                        <img :src="sponserURL + sponsor.image_url"
                                                            alt="Sponsor Image" />
                                                    </div>
                                                    <div class="sponsor-img" v-else>
                                                        <img src="../../../assets/images/sponsor.png" alt="" />
                                                    </div>
                                                </div>
                                                <p class="sponsor-name text-dark">{{
                                                    sponsor.name }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="event-btns-wrapper justify-content-end">
                                <div class="d-flex align-items-center">
                                    <button type="button" class="btn btn-primary" block @click="handleStepsFunctions()"
                                        :disabled="isLoadingArray[0]">
                                        <div v-if="isLoadingArray[0]"
                                            class="d-flex align-items-center justify-content-center">
                                            <div class="lds-dual-ring"></div>
                                        </div>
                                        <div v-else class="d-flex align-items-center">
                                            <span v-if="currentStep <= 2">Save & Continue</span>
                                            <span v-else-if="currentStep == 3">Next</span>
                                            <span v-else>Next Step: Add Event Teams</span>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-right-wrapper">
                        <EventWizardSummary :eventData="eventData" :brackeFormat="brackeFormat"
                            :selectedSeedCriteria="selectedSeedarsFromChild" :selectedParks="selectedParksFromChild"
                            :eventSponsors="eventSponsors" :eventHotels="eventHotels" />
                    </div>
                </div>
            </div>
        </div>
        <AddPark :eventId="eventId" :association_id="association_id" :parent-identifier="'EventWizardIsParent'"
            @open-main-modal-again="openMainModalFromAddPark" />
        <NewSponsor :eventId="eventId" :association_id="association_id"
            @open-main-modal-again="openMainModalFromSponsor" />
        <NewHotel :eventId="eventId" :association_id="association_id" @open-main-modal-again="openMainModal" />
    </div>
</template>

<script>
import axios from "axios";
import AddPark from './AddPark.vue';
import EventWizardSummary from './EventWizardSummary.vue';
import NewHotel from './NewHotel.vue';
import NewSponsor from './NewSponsor.vue';
import ParksComponent from './ParksComponent.vue';
import SeedingComponent from './SeedingComponent.vue';
import _ from 'lodash';

export default {
    name: "EventWizardSteps",
    components: {
        EventWizardSummary,
        SeedingComponent,
        ParksComponent,
        AddPark,
        NewSponsor,
        NewHotel
    },
    data() {
        return {
            eventData: {},
            eventId: "",
            association_id: "",
            currentStep: 1,
            isLoadingArray: [],
            marker: { position: { lat: 10, lng: 10 } },
            center: { lat: 10, lng: 10 },
            mapOptions: {
                disableDefaultUI: false,
                gestureHandling: 'cooperative', // allows zooming only with Ctrl + wheel on desktop
                disableDoubleClickZoom: true, // disables zoom on double-click
            },
            location: null,
            brackeFormat: "",
            bracketFormats: [],
            selectedParksFromChild: [],
            selectedSeedarsFromChild: [],
            showLoaderAvailableParks: 1,
            showLoaderSelectedParks: 1,
            availableParks: [],
            selectedParks: [],
            eventSponsors: [],
            eventHotels: [],
            sponsorLoader: 0,
            sponserURL: this.$eventSponserStorageURL,
            hotelURL: this.$eventHotelStorageURL,
            selectedPlaceData: null
        }
    },
    watch: {
        bracketFormats(newVal) {
            if (newVal && newVal.length > 0) {
                this.mapBracketFormat();
            }
        },
    },
    methods: {
        handleStateUpdate({ isDisabled, selectedParks }) {
            this.isDisabled = isDisabled;
            this.selectedParksFromChild = selectedParks;
        },
        handleUpdateSeedars({ isDisabled, selectedSeedars }) {
            this.isDisabled = isDisabled;
            this.selectedSeedarsFromChild = selectedSeedars;
        },
        resetData() {
            this.currentStep = 1;
            this.location = null;
        },
        closeModal() {
            var elem = this.$refs.closeModalEventWizards;
            if (elem) {
                elem.click();
            }
        },
        openMainModal() {
            var elem = this.$refs.openEventWizard;
            if (elem) {
                elem.click();
                this.getEventHotel();
                this.location = null;
                this.selectedPlaceData = null
                this.geolocate();
            }
        },
        openMainModalFromSponsor() {
            var elem = this.$refs.openEventWizard;
            if (elem) {
                elem.click();
                this.getEventSponsor();
            }
        },
        openMainModalFromAddPark(id) {
            if (id === "EventWizardIsParent") {
                var elem = this.$refs.openEventWizard;
                if (elem) {
                    elem.click();
                    const child = this.$refs.parksComponent;
                    if (child) {
                        child.getPlayingFacilities();
                        child.getPlayingFacilityForAssociation()
                    }
                }
            }
        },
        newSponsor() {
            this.$root.$emit("openNewSponsorModal");
            this.closeModal();
        },
        newHotel() {
            const hotelData = {
                position: this.marker.position,
                place: this.selectedPlaceData
            };
            this.closeModal();
            setTimeout(() => {
                this.$root.$emit("openNewHotelModal", hotelData);
            }, 500);

        },
        redirectToEvent() {
            localStorage.removeItem('division');
            localStorage.removeItem("tournamentID");
            localStorage.removeItem('tournament_id');
            const eventId = this.eventData.guid;

            this.$router.push({ name: 'AssociationSingleEventDetail', params: { id: eventId } });
        },
        handleStepsFunctions() {
            if (this.currentStep === 1) {
                this.manageSeedars(0);
            } else if (this.currentStep === 2) {
                this.manageParks(0);
            } else if (this.currentStep === 3) {
                this.currentStep++;
            } else if (this.currentStep === 4) {
                this.closeModal();
                this.redirectToEvent();
            }
        },
        async getEventHotel() {
            try {
                const response = await axios.get(
                    `${process.env.VUE_APP_API_URL}associationEvent/getEventHotels?event_id=${this.eventId}`
                );

                if (response.data.statusCode === 200) {
                    this.eventHotels = response.data.data;
                } else {
                    this.errorMessage = response.data.message || "Unknown error occurred";
                }
            } catch (error) {
                this.errorMessage = "Failed to fetch data";
            }
        },
        async getEventSponsor() {
            try {
                this.sponsorLoader = 1;
                const response = await axios.get(
                    `${process.env.VUE_APP_API_URL}associationEvent/getSponsor?event_id=${this.eventId}`
                );

                if (response.data.statusCode === 200) {
                    this.eventSponsors = response.data.data;
                    this.sponsorLoader = 0;
                } else {
                    this.errorMessage = response.data.message || "Unknown error occurred";
                    this.sponsorLoader = 0;
                }
            } catch (error) {
                this.errorMessage = "Failed to fetch data";
                this.sponsorLoader = 0;
            }
        },
        async getPlayingFacilityForAssociation() {
            try {
                this.showLoaderSelectedParks = 1;

                // Prepare the parameters
                const params = {
                    event_id: this.eventId,
                    association_id: this.association_id,
                };

                const response = await axios.get(
                    `${process.env.VUE_APP_API_URL}associationEvent/getEventPlayingFacility?event_id=${this.eventId}&association_id=${this.association_id}`,
                    { params } // Send parameters as query params
                );

                if (response.data.statusCode === 200) {
                    this.selectedParks = Object.values(response.data.data.parkDetails);
                    this.showLoaderSelectedParks = 0;
                }
                else if (response.data.statusCode === 404) {
                    this.closeModal();
                    // this.$alert(response.data.message, 'Error');
                    // this.$router.push({ name: "Teams" });
                }
                else {
                    this.errorMessage = response.data.message || "Unknown error occurred";
                    this.showLoaderSelectedParks = 0;
                }
            } catch (error) {
                this.errorMessage = "Failed to fetch data";
                this.showLoaderSelectedParks = 0;
            }
        },
        async getPlayingFacilities() {
            try {
                this.showLoaderAvailableParks = 1;
                const response = await axios.get(
                    `${process.env.VUE_APP_API_URL}associationEvent/getParksForEventManagement?event_id=${this.eventId}&association_id=${this.association_id}`
                );

                if (response.data.statusCode === 200) {
                    this.availableParks = Object.values(response.data.data.parks);
                    this.showLoaderAvailableParks = 0;
                } else if (response.data.statusCode === 404) {
                    this.closeModal();
                    this.$alert(response.data.message, 'Error');
                    this.$router.push({ name: "Teams" });
                } else {
                    this.errorMessage = response.data.message || "Unknown error occurred";
                    this.showLoaderAvailableParks = 0;
                }
            } catch (error) {
                this.errorMessage = "Failed to fetch data";
                this.showLoaderAvailableParks = 0;
            }
        },
        async manageParks(index) {
            this.$set(this.isLoadingArray, index, true);
            try {
                const url = `${process.env.VUE_APP_API_URL}associationEvent/createEventPark`;
                const response = await axios.post(url, {
                    event_id: this.eventId,
                    selectedParks: this.selectedParksFromChild ? this.selectedParksFromChild : "",
                    association_id: this.association_id,
                });

                // Handle the response based on statusCode
                if (response.data.statusCode === 200) {
                    console.log("oka")
                } else if (response.data.statusCode === 404) {
                    this.closeModal();
                    this.$alert(response.data.message, 'Error');
                    this.$router.push({ name: "Teams" });
                } else {
                    this.errorMessage = response.data.message || "Unknown error occurred";
                    this.$set(this.isLoadingArray, index, false);
                }
            } catch (error) {
                console.error("Error saving selected parks:", error);
            } finally {
                this.$set(this.isLoadingArray, index, false);
                this.currentStep++;
            }
        },
        async manageSeedars(index) {
            this.$set(this.isLoadingArray, index, true); // Show loading indicator

            try {
                const url = `${process.env.VUE_APP_API_URL}associationEvent/updateEventSeedCriteria`;
                const response = await axios.post(url, {
                    event_id: this.eventId,
                    association_id: this.association_id,
                    seed_criteria_defaults: this.selectedSeedarsFromChild,
                });

                // Check the response and handle accordingly
                if (response.data.statusCode === 200) {
                    // Success case
                    this.currentStep++;
                } else if (response.data.statusCode === 404) {
                    this.closeModal();
                    this.$alert(response.data.message, 'Error');
                    this.$router.push({ name: 'Teams' });
                } else {
                    this.closeModal();
                    this.$alert('Failed to update seed criteria. Please try again later.', 'Error');
                }
            } catch (error) {
                console.error("Error saving selected Seeding:", error);
                this.$alert('An unexpected error occurred. Please try again later.', 'Error');
            } finally {
                this.$set(this.isLoadingArray, index, false);
            }
        },
        handleThrottledMarkerDrag: _.throttle(function (event) {
            this.handleMarkerDrag(event);
        }, 50),
        handleMarkerDrag(e) {
            window.test = this;
            this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            var geocoder = new window.google.maps.Geocoder();
            var latlng = this.marker.position;
            geocoder.geocode({ location: latlng }, function (results, status) {
                if (status === "OK") {
                    if (results[1]) {
                        for (let i = 0; i < results.length; i++) {
                            // eslint-disable-next-line
                            window.test.location = results[2].formatted_address;
                            if (results[i]?.types[0] == "locality") {
                                for (let j = 0; j < results[i].address_components.length; j++) {
                                    if (results[i].address_components[j]?.types[0] == "locality") {
                                        window.test.city = results[i].address_components[j].long_name;
                                    }
                                }
                                // this.city = results[i].long_name;
                            }
                            if (
                                results[i]?.types[0] == "premise" ||
                                results[i]?.types[0] == "street_address" ||
                                results[i]?.types[0] == "route" ||
                                results[i]?.types[0] == "neighborhood"
                            ) {
                                for (let j = 0; j < results[i].address_components.length; j++) {
                                    if (
                                        results[i].address_components[j]?.types[0] == "route" ||
                                        results[i].address_components[j]?.types[0] == "street_address" ||
                                        results[i].address_components[j]?.types[0] == "premise"
                                    ) {
                                        window.test.street = results[i].address_components[j].long_name;
                                    }
                                }
                            }
                            if (results[i]?.types[0] == "administrative_area_level_1") {
                                for (let j = 0; j < results[i].address_components.length; j++) {
                                    if (
                                        results[i].address_components[j]?.types[0] ==
                                        "administrative_area_level_1"
                                    ) {
                                        window.test.state = results[i].address_components[j].long_name;
                                    }
                                }
                            }
                            if (results[i]?.types[0] == "postal_code") {
                                for (let j = 0; j < results[i].address_components.length; j++) {
                                    if (results[i].address_components[j]?.types[0] == "postal_code") {
                                        window.test.zipCode = results[i].address_components[j].long_name;
                                    }
                                }
                            }
                        }
                    } else {
                        window.alert("No results found");
                    }
                }
            });
        },
        geolocate() {
            navigator.geolocation.getCurrentPosition((position) => {
                this.marker.position = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                this.panToMarker();
            });
        },
        panToMarker() {
            if (this.marker?.position) {
                this.$refs.mapRef?.panTo(this.marker.position);
            }
        },
        //Moves the marker to click position on the map
        handleMapClick(e) {
            window.test = this;
            this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            var geocoder = new window.google.maps.Geocoder();
            var latlng = this.marker.position;
            geocoder.geocode({ location: latlng }, function (results, status) {
                if (status === "OK") {
                    if (results[0]) {
                        for (let i = 0; i < results.length; i++) {
                            // eslint-disable-next-line
                            window.test.location = results[2].formatted_address;
                            if (results[i]?.types[0] == "locality") {
                                for (let j = 0; j < results[i].address_components.length; j++) {
                                    if (results[i].address_components[j]?.types[0] == "locality") {
                                        window.test.city = results[i].address_components[j].long_name;
                                    }
                                }
                                // this.city = results[i].long_name;
                            }
                            if (
                                results[i]?.types[0] == "premise" ||
                                results[i]?.types[0] == "street_address" ||
                                results[i]?.types[0] == "route"
                            ) {
                                for (let j = 0; j < results[i].address_components.length; j++) {
                                    if (
                                        results[i].address_components[j]?.types[0] == "route" ||
                                        results[i].address_components[j]?.types[0] == "street_address" ||
                                        results[i].address_components[j]?.types[0] == "premise"
                                    ) {
                                        window.test.street = results[i].address_components[j].long_name;
                                    }
                                }
                            }
                            if (results[i]?.types[0] == "administrative_area_level_1") {
                                for (let j = 0; j < results[i].address_components.length; j++) {
                                    if (
                                        results[i].address_components[j]?.types[0] ==
                                        "administrative_area_level_1"
                                    ) {
                                        window.test.state = results[i].address_components[j].long_name;
                                    }
                                }
                            }
                            if (results[i]?.types[0] == "postal_code") {
                                for (let j = 0; j < results[i].address_components.length; j++) {
                                    if (results[i].address_components[j]?.types[0] == "postal_code") {
                                        window.test.zipCode = results[i].address_components[j].long_name;
                                    }
                                }
                            }
                        }
                    } else {
                        window.alert("No results found");
                    }
                }
            });
        },
        setPlace(place) {
            if (!place) return;
            this.$refs.autocompleteRef.$el.classList.add("custom-dropdown-open");
            this.marker.position = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };
            this.street = place.formatted_address;
            this.location = place.formatted_address;
            const addressComponents = place.address_components;

            for (const component of addressComponents) {
                const types = component.types;
                if (types.includes("locality")) {
                    this.city = component.long_name;
                } else if (types.includes("administrative_area_level_1")) {
                    this.state = component.short_name;
                } else if (types.includes("postal_code")) {
                    this.zipCode = component.long_name;
                }
            }
            this.panToMarker();
            this.selectedPlaceData = place;
        },
        getBracketFormat() {
            axios
                .get(`${process.env.VUE_APP_API_URL}getBracketFormats`)
                .then((response) => {
                    if (response.data.statusCode == 200) {
                        this.bracketFormats = response.data.data.list;
                        this.mapBracketFormat(); // ✅ Only map once data is loaded
                    } else {
                        this.errorMessage = response.data.message;
                    }
                });
        },
        mapBracketFormat() {
            const divisionType = (this.eventData.division_type || '').toLowerCase();
            let match = null;

            if (!isNaN(divisionType)) {
                const divisionId = parseInt(divisionType, 10);
                match = this.bracketFormats.find((b) => b.id === divisionId);
            } else {
                match = this.bracketFormats.find((b) =>
                    b.bracket_name.toLowerCase().includes(divisionType)
                );
            }

            // this.brackeFormat = match ? match.id : null;
            this.brackeFormat = match ? match.bracket_name : '';
        },
    },
    mounted() {
        this.$root.$on("openEventWizardModal", (response) => {
            this.eventData = response;
            this.eventId = response.id;
            this.association_id = response.association_id;

            const elem = this.$refs.openEventWizard;
            if (elem) {
                elem.click();
                this.resetData();
                this.geolocate();
                this.getBracketFormat();
            }
        });
    }
}
</script>